module.exports = __webpack_public_path__ + "static/media/experience.e2aa92db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/mobile/experience.svg
// module id = 269
// module chunks = 0